import { triggerBase64Download } from "../../../../../../../utils/base64Download"
import { format } from "date-fns"
import React, { useEffect, useState } from "react"
import { Col, Form, Row } from "react-bootstrap"
import toast from "react-hot-toast"
import { useDispatch } from "react-redux"
import { useParams } from "react-router-dom"
import Constant from "../../../../../../../../constant"
import Buttonaction from "../../../../../../../components/Buttonaction"
import DatePickerInput from "../../../../../../../components/DatePickerInput"
import { GreyCard } from "../../../../../../../components/styled/Generalcard"
import { getMyProfile } from "../../../../../../../redux/action/accountAction"
import { getGenerateReportNegoLogData, getNegotiationReport } from "../../../../../../../redux/action/reportAction"

// Same cap as the eproc Berita Acara "No Surat" field.
const LETTER_NUMBER_MAX_LENGTH = 64

export default function NegotiationReport(props) {
   const {
      negotiationId,
      procurementParamId,
      renderAsButton = false, // when true, render only the CTA button (used in scoring pages)
      buttonProps = {},
      winnerVendorId,
      finalNegotiationPrice,
      batchParamId,
      cardClassName = "mx-4 mb-5",
      onReportGenerated,
   } = props
   const { procurementId: procurementIdFromRoute, batchId: batchIdFromRoute, negotiationId: negotiationIdFromRoute } = useParams()
   const procurementId = procurementParamId ?? procurementIdFromRoute
   const batchId = batchParamId ?? batchIdFromRoute
   const resolvedNegotiationId = negotiationId ?? negotiationIdFromRoute
   const dispatch = useDispatch()

   const [downloading, setDownloading] = useState(false)
   const [companyId, setCompanyId] = useState()
   const [payload, setPayload] = useState({
      letterNumber: null,
      letterDate: new Date(),
      vendorOfferLetterNumber: null,
      vendorOfferLetterDate: new Date(),
      negotiationMedia: null,
      offlineLocation: "",
   })
   const [dataGenerateReport, setDataGenerateReport] = useState({})

   const getGenerateReportData = () => {
      if (!resolvedNegotiationId) return
      dispatch(
         getGenerateReportNegoLogData(resolvedNegotiationId, (res) => {
            if (!res) return
            setDataGenerateReport((prev) => ({
               ...prev,
               ...res,
               letterDate: new Date(res.letterDate),
               vendorOfferLetterDate: new Date(res.vendorOfferLetterDate),
            }))
            if (onReportGenerated) onReportGenerated()
         }),
      )
   }
   useEffect(() => {
      dispatch(
         getMyProfile((res) => {
            const companyId = res.account.companyId
            setCompanyId(companyId)
         }),
      )

      getGenerateReportData()
   }, [])

   const handleGenerateReport = () => {
      let _payload
      if (Object.entries(dataGenerateReport).length > 0) {
         _payload = dataGenerateReport
      } else {
         _payload = payload
      }
      new Promise((resolve, reject) => {
         setDownloading(true)

         dispatch(
            getNegotiationReport(
               procurementId,
               companyId,
               batchId,
               resolvedNegotiationId,
               { ..._payload, finalNegotiationPrice },
               (resp) => {
                  // docx
                  resolve(
                     `data:application/vnd.openxmlformats-officedocument.wordprocessingml.document;base64,${resp.data}`,
                  )
                  if (onReportGenerated) onReportGenerated()
                  // pdf
                  // resolve(`data:application/pdf;base64,${resp.data}`)
               },
               () => {
                  reject(new Error("Failed to download"))
               },
            ),
         )
      })
         .then((base64) => {
            triggerBase64Download(
               base64,
               "BERITA ACARA KLARIFIKASI DAN NEGOSIASI " + format(new Date(Date.now()), "dd-MMMM-yyyy kk:mm:ss"),
            )
            getGenerateReportData()
         })
         .catch((err) => {
            console.log(err)
            toast.error("Failed to generate & download report")
         })
         .finally(() => {
            setDownloading(false)
         })
   }

   // If used as a bare button (e.g., in scoring list headers), skip the card wrapper.
   if (renderAsButton) {
      return (
         <Buttonaction
            blueOcean
            label="Generate & Download Report"
            loadingLabel="Generating Report..."
            loading={downloading}
            onClick={handleGenerateReport}
            {...buttonProps}
         />
      )
   }

   return (
      <GreyCard className={cardClassName}>
         <Row>
            <Col className="d-flex justify-content-between align-items-center ml-3 mt-2">
               <p
                  style={{
                     fontSize: "18px",
                     fontWeight: "bold",
                     color: "#454545",
                     marginTop: "10px",
                  }}
               >
                  Official Report
               </p>
            </Col>
         </Row>
         <hr style={{ background: "#C4C4C4" }} />
         <Row className="d-flex align-items-center ml-1" style={{ marginBottom: 18 }}>
            <Col className="px-3">Letter Number</Col>
            <Col lg={9}>
               {dataGenerateReport.letterNumber ? (
                  <p className="mb-0">{dataGenerateReport.letterNumber}</p>
               ) : (
                  <Form.Control
                     placeholder="01/NEG-02/2021"
                     size="lg"
                     style={{ width: "39%" }}
                     maxLength={LETTER_NUMBER_MAX_LENGTH}
                     onChange={(e) => setPayload((prev) => ({ ...prev, letterNumber: e.target.value }))}
                  />
               )}
            </Col>
         </Row>
         <Row className="d-flex align-items-center ml-1" style={{ marginBottom: 18 }}>
            <Col className="px-3">Letter Date</Col>
            <Col lg={9}>
               {dataGenerateReport.letterDate ? (
                  <p className="mb-0">{format(dataGenerateReport.letterDate, "dd MMMM yyyy")}</p>
               ) : (
                  <DatePickerInput
                     placeholder="dd/mm/yyyy"
                     value={payload.letterDate}
                     onChange={(v) => setPayload((prev) => ({ ...prev, letterDate: v }))}
                     style={{ width: 260 }}
                     container={() => document.body}
                     menuStyle={{ zIndex: 1060 }}
                  />
               )}
            </Col>
         </Row>
         <Row className="d-flex align-items-center ml-1" style={{ marginBottom: 18 }}>
            <Col className="px-3">Vendor Offer Letter Number</Col>
            <Col lg={9}>
               {dataGenerateReport.vendorOfferLetterNumber ? (
                  <p className="mb-0">{dataGenerateReport.vendorOfferLetterNumber}</p>
               ) : (
                  <Form.Control
                     placeholder="01/NEG-02/2021"
                     size="lg"
                     style={{ width: "39%" }}
                     maxLength={LETTER_NUMBER_MAX_LENGTH}
                     onChange={(e) => setPayload((prev) => ({ ...prev, vendorOfferLetterNumber: e.target.value }))}
                  />
               )}
            </Col>
         </Row>
         <Row className="d-flex align-items-center ml-1" style={{ marginBottom: 18 }}>
            <Col className="px-3">Vendor Offer Letter Date</Col>
            <Col lg={9}>
               {dataGenerateReport.vendorOfferLetterDate ? (
                  <p className="mb-0">{format(dataGenerateReport.vendorOfferLetterDate, "dd MMMM yyyy")}</p>
               ) : (
                  <DatePickerInput
                     placeholder="dd/mm/yyyy"
                     value={payload.vendorOfferLetterDate}
                     onChange={(v) => setPayload((prev) => ({ ...prev, vendorOfferLetterDate: v }))}
                     style={{ width: 260 }}
                     container={() => document.body}
                     menuStyle={{ zIndex: 1060 }}
                  />
               )}
            </Col>
         </Row>
         <Row className="d-flex align-items-center ml-1" style={{ marginBottom: 18 }}>
            <Col className="px-3">Negotiation Media</Col>
            <Col lg={9}>
               {dataGenerateReport.negotiationMedia ? (
                  <p className="mb-0">{dataGenerateReport.negotiationMedia}</p>
               ) : (
                  <Form.Group className="d-flex mb-0" controlId="negotiationMedia">
                     <Form.Check
                        type="radio"
                        name="media"
                        id="online"
                        label="Online"
                        value="online"
                        className="mr-3"
                        onClick={(v) =>
                           setPayload((prev) => ({ ...prev, negotiationMedia: v.target.value, offlineLocation: "" }))
                        }
                     />
                     <Form.Check
                        type="radio"
                        name="media"
                        id="offline"
                        label="Offline"
                        value="offline"
                        onClick={(v) => setPayload((prev) => ({ ...prev, negotiationMedia: v.target.value }))}
                     />
                  </Form.Group>
               )}
            </Col>
         </Row>
         <Row
            className={`d-flex ml-1 ${
               dataGenerateReport.negotiationMedia === "offline" ? "align-items-start" : "align-items-center"
            }`}
            style={{ marginBottom: 18 }}
         >
            <Col className="px-3">Offline Location</Col>
            <Col lg={9}>
               {dataGenerateReport.negotiationMedia === "online" ? (
                  <p className="mb-0">-</p>
               ) : dataGenerateReport.negotiationMedia === "offline" ? (
                  <p className="mb-0" style={{ width: "39%" }}>{dataGenerateReport.offlineLocation}</p>
               ) : (
                  <Form.Control
                     as="textarea"
                     type="text"
                     value={payload.offlineLocation}
                     size="lg"
                     style={{ width: "39%", fontSize: "12px" }}
                     disabled={payload.negotiationMedia === "online"}
                     onChange={(e) => setPayload((prev) => ({ ...prev, offlineLocation: e.target.value }))}
                  />
               )}
            </Col>
         </Row>
         <Row className="d-flex align-items-center ml-1" style={{ marginBottom: 12 }}>
            <Col className="px-3">Berita Acara</Col>
            <Col lg={9}>
               {!Object.entries(dataGenerateReport).length > 0 ? (
                  <Buttonaction
                     style={{ width: "39%" }}
                     disabled={
                        !payload.letterDate ||
                        !payload.letterNumber ||
                        !payload.vendorOfferLetterNumber ||
                        !payload.vendorOfferLetterDate ||
                        !payload.negotiationMedia ||
                        (payload.negotiationMedia === "offline" && !payload.offlineLocation) ||
                        downloading
                     }
                     blueOcean
                     label="Generate & Download Report"
                     loadingLabel="Generating Report..."
                     loading={downloading}
                     onClick={handleGenerateReport}
                  />
               ) : (
                  <Buttonaction
                     style={{ width: "39%" }}
                     blueOcean
                     label="Generate & Download Report"
                     loadingLabel="Generating Report..."
                     loading={downloading}
                     onClick={handleGenerateReport}
                  />
               )}
               <div className="mt-1">
                  <span style={{ fontSize: 12, color: "#8F8F8F" }}>
                     This files include Official Report ( Berita Acara )
                  </span>
               </div>
            </Col>
         </Row>
      </GreyCard>
   )
}
